import { ICS2InformationExchangeMessages } from 'store/declarations/eu/ics2/ICS2InformationExchangeMessages';
import {
    Ics2CustomsRequest,
    Ics2ReferralStatus,
    Ics2ReferralSubmission,
    Ics2ReferralType,
    Ics2RequestPayload,
} from './types';

/**
 * The three statuses the backend accepts a draft save or a submission for
 * (`Ics2ReferralProgress` in declarations-service). Everything else is read-only: the answer is
 * in flight, already sent, or resolved.
 */
const EDITABLE_STATUSES: Ics2ReferralStatus[] = [
    Ics2ReferralStatus.ACTION_REQUIRED,
    Ics2ReferralStatus.RESPONSE_IN_PROGRESS,
    Ics2ReferralStatus.RESPONSE_REJECTED,
];

export const isReferralEditable = (status?: Ics2ReferralStatus): boolean =>
    Boolean(status && EDITABLE_STATUSES.includes(status));

export const isAmendmentReferral = (requestType?: Ics2ReferralType | string): boolean =>
    requestType === Ics2ReferralType.AMD;

export const getResponseMessageType = (request?: Ics2CustomsRequest): 'IE3R02' | 'IE3R03' =>
    request?.messageType === ICS2InformationExchangeMessages.IE3Q03 ? 'IE3R03' : 'IE3R02';

// Note: To be tested once we have actual data (currently the BE seeds mock) and remove one of the mrn fields from the payload
/**
 * The inbound payload is a JAXB object serialized by plain Jackson. Whether the MRN key survives
 * as `MRN` or is mangled to `mrn` depends on Jackson's bean naming, and declarations-service's own
 * fixtures disagree, so accept both. Prefer the promoted `Ics2CustomsRequest.mrn` where available.
 */
export const readPayloadMrn = (payload?: Ics2RequestPayload): string | undefined => payload?.mrn ?? payload?.MRN;

/** Same ambiguity as the MRN, one level down. */
export const readPayloadIssueDate = (payload?: Ics2RequestPayload): string | undefined =>
    payload?.documentIssueDate?.dateTime ?? payload?.documentIssueDate?.DateTime;

export const getRequestMrn = (request?: Ics2CustomsRequest): string | undefined =>
    request?.mrn ?? readPayloadMrn(request?.requestPayload);

export const getRequestIssueDate = (request?: Ics2CustomsRequest): string | undefined =>
    request?.documentIssueDate ?? readPayloadIssueDate(request?.requestPayload);

export const getSubmissionReferralIds = (submission?: Ics2ReferralSubmission): string[] => {
    if (!submission?.referralVersions) return [];
    try {
        const parsed = JSON.parse(submission.referralVersions);
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? Object.keys(parsed) : [];
    } catch {
        return [];
    }
};
